import React, { useMemo } from "react";
import { Vector3 } from "three";
import { useDispatch, useSelector } from "react-redux";
import { setHighlightPoint } from "../../Actions/ApplicationStateAction";

const PointGeometry = ({ 
  position, 
  isHighlighted = false, 
  opacity = 0.5,
  designStep,
  pointId = null
}) => {
  const dispatch = useDispatch();
  
  // Convert position to Vector3 if it isn't already
  const pointPosition = useMemo(() => {
    return position instanceof Vector3 ? position : new Vector3(position.x, position.y, position.z);
  }, [position]);

  return (
    <mesh
      position={pointPosition}
      onPointerOver={() => {
        if (designStep === 2) {
          dispatch(setHighlightPoint(position));
        }
      }}
      onPointerOut={() => {
        dispatch(setHighlightPoint(null));
      }}
    >
      <sphereGeometry args={[isHighlighted ? 10 : 4, 16, 16]} />
      <meshBasicMaterial
        color={isHighlighted ? "#4B73EC" : "#2E2E2E"}
        transparent={true}
        opacity={opacity}
      />
    </mesh>
  );
};

export default PointGeometry;